module.exports = __webpack_public_path__ + "img/6.d80ba1aa.png";